import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { F as Flex } from '../Flex/Flex-DIrgiHUL.js';
import { H as Heading } from '../Heading/Heading-D51w1umc.js';
import { C as CloseButton } from '../Button/CloseButton/CloseButton-CyF4y8Vt.js';

const AnchoredAlertContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-11o51bo-0"
})(["padding:", ";overflow:visible;max-width:", ";max-height:", ";", ""], ({
  theme
}) => theme.spacing.small.default, ({
  theme
}) => theme.tooltip.maxWidth, ({
  theme
}) => theme.tooltip.maxHeight, isMobile(css(["padding:", ";"], ({
  theme
}) => theme.spacing.small.mobile)));
const AnchoredAlertScrollContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-11o51bo-1"
})(["overflow-x:auto;"]);
const AnchoredAlertMessage = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-11o51bo-2"
})(["font:", ";", " color:", ";"], ({
  theme
}) => theme.font.text.base.default, isMobile(css(["font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)), ({
  theme,
  $variant
}) => {
  if ($variant === 'inverted' || $variant === 'spotlight') {
    return theme.text.color.inverted;
  }
  return theme.text.color.default;
});
const FlexContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-11o51bo-3"
})(["display:flex;align-items:flex-start;flex-direction:column;"]);
const HeaderWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-11o51bo-4"
})(["display:flex;justify-content:space-between;align-items:flex-start;width:100%;margin-block-end:", ";"], ({
  theme
}) => theme.controls.headerGap.default);
const AnchoredAlertContentContainer = ({
  children,
  closeButtonLabel = 'Close Tooltip',
  handleCloseClicked,
  header,
  headerLevel,
  footer,
  message = undefined,
  variant = 'default',
  withCloseButton = true
}) => {
  const CloseButtonIcon = () => /*#__PURE__*/React__default.createElement(CloseButton, {
    size: "small",
    "aria-label": closeButtonLabel,
    onClick: handleCloseClicked,
    inverted: variant === 'inverted' || variant === 'spotlight'
  });
  return /*#__PURE__*/React__default.createElement(AnchoredAlertScrollContainer, null, /*#__PURE__*/React__default.createElement(AnchoredAlertContent, null, /*#__PURE__*/React__default.createElement(Flex, {
    direction: header ? 'column' : 'row-reverse',
    columnGap: "xsmall",
    alignItems: "flex-start"
  }, header && /*#__PURE__*/React__default.createElement(HeaderWrapper, null, /*#__PURE__*/React__default.createElement(Heading, {
    renderAs: headerLevel,
    size: "medium"
  }, header), withCloseButton && /*#__PURE__*/React__default.createElement(CloseButtonIcon, null)), !header && withCloseButton && /*#__PURE__*/React__default.createElement(CloseButtonIcon, null), /*#__PURE__*/React__default.createElement(AnchoredAlertMessage, {
    $variant: variant
  }, message || children)), footer && /*#__PURE__*/React__default.createElement(FlexContainer, null, footer)));
};

export { AnchoredAlertContentContainer as A };
//# sourceMappingURL=AnchoredAlertContent-BgapYUL9.js.map
